module.exports = __webpack_public_path__ + "img/CharacterSheetPage1.e48874f6.png";